import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'

export type PastilleProps = React.HTMLAttributes<HTMLDivElement> & {
  /** @default 'medium' */
  size?: 'extraSmall' | 'small' | 'medium'
  /** @default false */
  noBorder?: boolean
}

function PastilleComponent({ size, noBorder, children, ...rest }: PastilleProps): React.ReactElement<PastilleProps> {
  return (
    <S.image.Pastille size={size} noBorder={noBorder} {...rest}>
      {children}
    </S.image.Pastille>
  )
}

export const Pastille = styled(PastilleComponent)<PastilleProps>``
Pastille.displayName = 'Pastille'
